import { TrackingProfile } from "../../lib/accountUtils";
import createReducer from "../../lib/createReducer";
import { LOAD_TRACKINGDATA } from "../actions";

export interface TrackingDataState extends TrackingProfile {
	isLoaded: boolean; // flag to indicate if the tracking data has been loaded
  [key: string]: any; //  allow any other properties to be added
};

const initialState = {
  email: undefined,
  firstname: undefined,
  lastname: undefined,
  auth_status: 'anonymous',
  anonymous_uuid: undefined,
  uuid: undefined,
  is_returning: true,
  lastupdated: new Date().toISOString(),
	isLoaded: false, // initially not loaded
};

const handleTrackingDataData = (state: TrackingDataState, payload: TrackingProfile): TrackingDataState => {
	// console.log('[Reducer] Handling _FULFILLED with payload:', payload);
	const { dotDigital, ...profile } = payload;
	return {
		...state,
		...profile,
		firstname: payload.given_names,	// construct from API data
		lastname: payload.last_name,	// construct from API data
		isLoaded: true, // set the flag to true when data is loaded
	}
};

const handlers = {
  [LOAD_TRACKINGDATA + '_FULFILLED']: handleTrackingDataData,
};

export default createReducer(handlers, initialState);